"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyPresetSnackbar = void 0;

const CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));

const Close_1 = __importDefault(require("@mui/icons-material/Close"));

const Error_1 = __importDefault(require("@mui/icons-material/Error"));

const Info_1 = __importDefault(require("@mui/icons-material/Info"));

const Warning_1 = __importDefault(require("@mui/icons-material/Warning"));

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const SskyButton_1 = __importDefault(require("../SskyButton"));

const SskyMuiDarkTheme_1 = __importDefault(require("../SskyMuiDarkTheme"));

const SskySnackbar_1 = __importDefault(require("../SskySnackbar"));

const VARIANT_BACKGROUND_COLOR_MAP = {
  success: "#339900",
  error: "#FF3333",
  info: "#313131",
  warning: "#FF9900"
};
const StyledCloseIcon = (0, material_1.styled)(Close_1.default)({
  fontSize: 20
});
const SnackbarContentMessage = (0, material_1.styled)("span")({
  display: "flex",
  alignItems: "center"
});

const iconSxProps = theme => ({
  fontSize: 20,
  opacity: 0.9,
  marginRight: theme.spacing(1)
});

const variantIcon = {
  success: CheckCircle_1.default,
  warning: Warning_1.default,
  error: Error_1.default,
  info: Info_1.default
};

const SskyPresetSnackbar = props => {
  var _a, _b;

  const getSnackbarIcon = () => {
    const iconProps = {
      sx: iconSxProps
    };
    const DefaultIcon = variantIcon[props.variant];
    const icon = props.icon ? react_1.default.cloneElement(props.icon, iconProps) : react_1.default.createElement(DefaultIcon, Object.assign({}, iconProps));
    return props.showIcon ? icon : null;
  };

  const actionButtons = props.action.map(actionButton => react_1.default.createElement(SskyMuiDarkTheme_1.default, {
    key: actionButton.label
  }, react_1.default.createElement(SskyButton_1.default, {
    variant: "outlined",
    color: props.variant === "info" ? "primary" : "inherit",
    label: actionButton.label,
    onClick: actionButton.onClick,
    dataTestId: actionButton.dataTestId || `test-id-ssky-preset-snackbar-action-button-${actionButton.label}`
  })));

  if (props.showCloseButton) {
    const closeButton = react_1.default.createElement(material_1.IconButton, {
      key: "close",
      color: "inherit",
      onClick: props.onClose
    }, react_1.default.createElement(StyledCloseIcon, null));
    actionButtons.push(closeButton);
  }

  return react_1.default.createElement(SskySnackbar_1.default, {
    anchorOrigin: props.anchorOrigin,
    open: props.open,
    key: (_b = (_a = props.message) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "",
    onClose: props.onClose,
    duration: props.duration,
    dataTestId: props.dataTestId,
    direction: props.direction
  }, react_1.default.createElement(material_1.SnackbarContent, {
    sx: {
      backgroundColor: VARIANT_BACKGROUND_COLOR_MAP[props.variant]
    },
    message: react_1.default.createElement(SnackbarContentMessage, null, getSnackbarIcon(), props.message),
    action: actionButtons
  }));
};

exports.SskyPresetSnackbar = SskyPresetSnackbar;
SskyPresetSnackbar.defaultProps = {
  action: [],
  showIcon: true,
  showCloseButton: true
};
exports.default = react_1.default.memo(SskyPresetSnackbar);